module.exports = __webpack_public_path__ + "img/11.afd54f3d.svg";